import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LibraryItemDataTransformMutationVariables = Types.Exact<{
  input: Types.DataTransformInput;
}>;


export type LibraryItemDataTransformMutation = { __typename?: 'Mutation', createOrUpdateDataTransform: { __typename?: 'DataTransformMutationResult', success: boolean, dataTransform?: { __typename?: 'DataTransform', id: string, output: { __typename?: 'TranslationSet', en: string } } | null, error?: { __typename?: 'Error', code: string } | null } };


export const LibraryItemDataTransformDocument = gql`
    mutation LibraryItemDataTransform($input: DataTransformInput!) {
  createOrUpdateDataTransform(input: $input) {
    success
    dataTransform {
      id
      output {
        en
      }
    }
    error {
      code
    }
  }
}
    `;
export type LibraryItemDataTransformMutationFn = Apollo.MutationFunction<LibraryItemDataTransformMutation, LibraryItemDataTransformMutationVariables>;

/**
 * __useLibraryItemDataTransformMutation__
 *
 * To run a mutation, you first call `useLibraryItemDataTransformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLibraryItemDataTransformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [libraryItemDataTransformMutation, { data, loading, error }] = useLibraryItemDataTransformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLibraryItemDataTransformMutation(baseOptions?: Apollo.MutationHookOptions<LibraryItemDataTransformMutation, LibraryItemDataTransformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LibraryItemDataTransformMutation, LibraryItemDataTransformMutationVariables>(LibraryItemDataTransformDocument, options);
      }
export type LibraryItemDataTransformMutationHookResult = ReturnType<typeof useLibraryItemDataTransformMutation>;
export type LibraryItemDataTransformMutationResult = Apollo.MutationResult<LibraryItemDataTransformMutation>;
export type LibraryItemDataTransformMutationOptions = Apollo.BaseMutationOptions<LibraryItemDataTransformMutation, LibraryItemDataTransformMutationVariables>;